import { render, staticRenderFns } from "./action-plan.component.vue?vue&type=template&id=b9574b36&scoped=true&"
import script from "./action-plan.component.vue?vue&type=script&lang=ts&"
export * from "./action-plan.component.vue?vue&type=script&lang=ts&"
import style0 from "./action-plan.component.vue?vue&type=style&index=0&id=b9574b36&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9574b36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSelect,VTextarea})
